module.exports = __webpack_public_path__ + "img/cruzeiro-sign.3fa82393.svg";